import React, { useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, InputAdornment, Pagination, PaginationItem, TablePagination, TextField } from '@mui/material';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent, tableCellClasses } from '@mui/material';
import PDF from '../../../assets/images/ExportPDF.png';
import Excel from '../../../assets/images/ExportExcel.png';
import Profileicon from '../../../assets/images/AccountWhite.png';
import { IMAGES_ICON } from "../../assets/images/exportImages";
import SearchIcon from '@mui/icons-material/Search';
import chevronRight from '../../assets/images/chevron-right.png'
import FilterIcon from '../../assets/images/filter.png'
import Download from '../../assets/images/download.png'
import Maximize from '../../assets/images/maximize-2.png'
import Grid from '../../assets/images/grid.png'
import { Box, Typography } from "@mui/material";

function createData(
    sno: string,
    customerName: string,
    caseCreated: string,
    referenceNo: string,
    product: string,
    branch: string,
    applicantName: string,
    coApplicantName: string,
    mobileNo: string,
    address: string
) {
    return {
        sno,
        customerName,
        caseCreated,
        referenceNo,
        product,
        branch,
        applicantName,
        coApplicantName,
        mobileNo,
        address
    };
}

const rows = [
    createData('01', 'State Bank of India', 'Jan 2025', '3112300', 'Home Loan', 'Test Branch 123', 'Santhosh Kumar', 'Santhosh Kumar', '98765 43210', '63, 2nd stn'),
    createData('02', 'State Bank of India', 'Feb 2025', '3112300', 'Personal Loan', 'Test Branch 123', 'Darshan', 'Darshan', '98765 43210', '63, 2nd stn'),
    createData('03', 'State Bank of India', 'March 2025', '3112300', 'Jewel Loan', 'Test Branch 123', 'Samuel Jackson', 'Samuel Jackson', '98765 43210', '63, 2nd stn'),
    createData('04', 'State Bank of India', 'Jan 2025', '3112300', 'Life Insurance', 'Test Branch 123', 'Emmanuel', 'Emmanuel', '98765 43210', '63, 2nd stn'),
    createData('05', 'State Bank of India', 'Feb 2025', '3112300', 'Home Loan', 'Test Branch 123', 'Sai Sriram', 'Sai Sriram', '98765 43210', '63, 2nd stn'),
    createData('06', 'State Bank of India', 'March 2025', '3112300', 'Personal Loan', 'Test Branch 123', 'Santhosh Kumar', 'Santhosh Kumar', '98765 43210', '63, 2nd stn'),
    createData('07', 'State Bank of India', 'Apr 2025', '3112300', 'Jewel Loan', 'Test Branch 123', 'Darshan', 'Darshan', '98765 43210', '63, 2nd stn'),
    createData('08', 'State Bank of India', 'May 2025', '3112300', 'Life Insurance', 'Test Branch 123', 'Samuel Jackson', 'Samuel Jackson', '98765 43210', '63, 2nd stn')
];


function Report() {

    const primaryColor = "#1A3353";
    const [_preCasePage, _setPreCasePage] = useState(1);
    const [selected, setSelected] = useState<"RCU" | "CPV" | "Employment">("RCU");
    const [selectedOption, setSelectedOption] = useState("precase");
    const [_requestDataCount, _setRequestdataCount] = useState<any>({});
    const [_page, _setPage] = useState(1);
    const [_rowsPerPage, _setRowsPerPage] = useState(10)
    const [_requestData, _setRequestdata] = useState<any>([]);
    const handleClick = (value: "RCU" | "CPV" | "Employment") => {
        setSelected(value);
    };

    const handleTabClick = (value: string) => {
        setSelectedOption(value);
    };

    const toggleVisibility = () => {

    };

     const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        _setPage(newPage + 1);
    };

    const handleChangePage1 = (event: React.ChangeEvent<unknown>, value: number) => {
        _setPage(value);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        _setRowsPerPage(newRowsPerPage);
        _setPage(1);
    };

    const preCasehandlePagination = (event: React.ChangeEvent<unknown>, value: number) => {
        _setPreCasePage(value);
    };

    return (<>
        <div className="d-flex align-items-center bg-primary text-white p-3">
            {/* <div><h5 className="mb-0"><span className="mx-2"><img src={Profileicon}/></span>Account-Payroll</h5></div> */}
            {/* <div><h5 className="mb-0"><span className="mx-2"><img src={IMAGES_ICON.FinanceIcon} style={{ filter: "brightness(0) invert(1)" }} /></span>Finance</h5></div> */}
            <img src={IMAGES_ICON.ReportIcon} alt="Left Arrow" className="me-2" style={{ width: '24px', height: '24px', filter: "brightness(0) invert(1)" }} />
            <h5 className="mb-0">Reports </h5>
            {/* <img src={chevronRight} alt="Left Arrow" className="me-2 mt-1" style={{ width: '20px', height: '20px' }} />
            <h5 className="mb-0">Invoice</h5> */}
        </div>
        <div className="bg-white" style={{ paddingLeft: 18, paddingTop: 10 }}>
            {/* Top Tabs */}
            <Box display="flex" gap={4} pb={1}>
                {["RCU", "CPV", "Employment"].map((option) => (
                    <Typography
                        key={option}
                        onClick={() => handleClick(option as "RCU" | "CPV" | "Employment")}
                        sx={{
                            cursor: "pointer",
                            paddingBottom: "6px",
                            borderBottom:
                                selected === option ? `2px solid ${primaryColor}` : "2px solid transparent",
                            color: selected === option ? "#1A3353" : "#B0B7C3",
                            fontWeight: selected === option ? "bold" : "normal",
                            transition: "all 0.2s ease",
                        }}
                    >
                        {option}
                    </Typography>
                ))}
            </Box>

            {/* Sub Tabs */}
            <div className="d-flex justify-content-between align-items-center">

                {/* {selected === "RCU" && (
                    <div className="d-flex bg-light">
                        <div
                            className={`border py-2 px-3 ${selectedOption === "precase" ? "text-primary border-primary" : ""
                                }`}
                            style={{
                                backgroundColor: selectedOption === "precase" ? "#D7E8FF" : "",
                                cursor: "pointer",
                                borderTopLeftRadius: "10px",
                                borderBottomLeftRadius: "10px",
                            }}
                            onClick={() => handleTabClick("precase")}
                        >
                            Loan Pre-Case
                        </div>

                        <div
                            className={`border py-2 px-3 ${selectedOption === "postcase" ? "text-primary border-primary" : ""
                                }`}
                            style={{
                                backgroundColor: selectedOption === "postcase" ? "#D7E8FF" : "",
                                cursor: "pointer",
                                borderTopRightRadius: "10px",
                                borderBottomRightRadius: "10px",
                            }}
                            onClick={() => handleTabClick("postcase")}
                        >
                            Loan Post-Case
                        </div>
                    </div>
                )}

                {selected === "CPV" && (
                    <div className="d-flex bg-light">
                        <div
                            className={`border py-2 px-3 ${selectedOption === "residence" ? "text-primary border-primary" : ""
                                }`}
                            onClick={() => handleTabClick("residence")}
                        >
                            Residence
                        </div>

                        <div
                            className={`border py-2 px-3 ${selectedOption === "office" ? "text-primary border-primary" : ""
                                }`}
                            onClick={() => handleTabClick("office")}
                        >
                            Office
                        </div>

                        <div
                            className={`border py-2 px-3 ${selectedOption === "business" ? "text-primary border-primary" : ""
                                }`}
                            style={{
                                borderTopRightRadius: "10px",
                                borderBottomRightRadius: "10px",
                            }}
                            onClick={() => handleTabClick("business")}
                        >
                            Business
                        </div>
                    </div>
                )}

                {selected === "Employment" && (
                    <div className="d-flex bg-light">
                        <div
                            className={`border py-2 px-3 ${selectedOption === "preemployment"
                                    ? "text-primary border-primary"
                                    : ""
                                }`}
                            style={{
                                backgroundColor:
                                    selectedOption === "preemployment" ? "#D7E8FF" : "",
                                cursor: "pointer",
                                borderTopLeftRadius: "10px",
                                borderBottomLeftRadius: "10px",
                            }}
                            onClick={() => handleTabClick("preemployment")}
                        >
                            Pre-Employment
                        </div>

                        <div
                            className={`border py-2 px-3 ${selectedOption === "postemployment"
                                    ? "text-primary border-primary"
                                    : ""
                                }`}
                            style={{
                                backgroundColor:
                                    selectedOption === "postemployment" ? "#D7E8FF" : "",
                                cursor: "pointer",
                                borderTopRightRadius: "10px",
                                borderBottomRightRadius: "10px",
                            }}
                            onClick={() => handleTabClick("postemployment")}
                        >
                            Post-Employment
                        </div>
                    </div>
                )} */}

            </div>
        </div>
        <div className="bg-white p-3 mb-3 rounded">
            <div className="row">

                {/* Customer Name */}
                <div className="col-md-3 mb-3">
                    <div className="from-label mb-2"><b>Customer Name</b></div>
                    <FormControl size="small" fullWidth>
                        <Select defaultValue="">
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="sbi">State Bank of India</MenuItem>
                            <MenuItem value="hdfc">HDFC Bank</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                {/* Status */}
                <div className="col-md-3 mb-3">
                    <div className="from-label mb-2"><b>Status</b></div>
                    <FormControl size="small" fullWidth>
                        <Select defaultValue="">
                            <MenuItem value="completed">Completed</MenuItem>
                            <MenuItem value="started">Started</MenuItem>
                            <MenuItem value="progress">In Progress</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                {/* Verifier */}
                <div className="col-md-3 mb-3">
                    <div className="from-label mb-2"><b>Verifier</b></div>
                    <FormControl size="small" fullWidth>
                        <Select defaultValue="">
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="ver1">Verifier 1</MenuItem>
                            <MenuItem value="ver2">Verifier 2</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                {/* Case Type */}
                <div className="col-md-3 mb-3">
                    <div className="from-label mb-2"><b>Case Type</b></div>
                    <FormControl size="small" fullWidth>
                        <Select defaultValue="">
                            <MenuItem value="precase">Pre-Case</MenuItem>
                            <MenuItem value="postcase">Post-Case</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                {/* Product Name */}
                <div className="col-md-3 mb-3">
                    <div className="from-label mb-2"><b>Product Name</b></div>
                    <FormControl size="small" fullWidth>
                        <Select defaultValue="">
                            <MenuItem value="homeloan">Home Loan</MenuItem>
                            <MenuItem value="personalloan">Personal Loan</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                {/* From Date */}
                <div className="col-md-3 mb-3">
                    <div className="from-label mb-2"><b>From Date</b></div>
                    <TextField
                        type="date"
                        size="small"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />
                </div>

                {/* To Date */}
                <div className="col-md-3 mb-3">
                    <div className="from-label mb-2"><b>To Date</b></div>
                    <TextField
                        type="date"
                        size="small"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />
                </div>

                {/* Search Button */}
                <div className="col-md-3 mb-3 d-flex align-items-end">
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#2D6CDF",
                            textTransform: "none",
                            px: 4,
                        }}
                    >
                        Search
                    </Button>
                </div>

            </div>
        </div>
        <div className="bg-white p-3 content-area" style={{ marginTop: -17 }}>
            <div className="bg-primary py-3 gx-0 text-white ps-3 row d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center col-auto">
                    <div className="fs-15 me-3" onClick={toggleVisibility} style={{ cursor: "pointer" }}>Reports</div>
                    <div className="col-auto">
                        <TextField
                            variant="outlined"
                            autoComplete="off"
                            size="small"
                            className="text-white border border-white white-input"
                            placeholder="Search..."
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon style={{ color: '#4E4E4E' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                </div>

                <div className="d-flex align-items-center gap-3 col-auto mx-4">
                    <img role="button" className="bg-dash p-2" src={FilterIcon} alt="Filter Icon" draggable="false" />
                    <img role="button" className="" src={Maximize} alt="Maximize Icon" draggable="false" />
                    <img role="button" className="" src={Grid} alt="Grid Icon" draggable="false" />
                    <img role="button" className="" src={Download} alt="Download Icon" draggable="false" />

                </div>
            </div>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">S.No</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Customer Name</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Case Created on</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Reference No</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Product</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Branch</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Applicant Name</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Co-Applicant Name</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Mobile No</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }} align="center">Address</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.sno}>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.sno}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.customerName}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.caseCreated}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.referenceNo}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.product}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.branch}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.applicantName}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.coApplicantName}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.mobileNo}</TableCell>
                                <TableCell style={{ whiteSpace: "nowrap" }} align="center">{row.address}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3 pb-4">
            <TablePagination
                className="proposalPagination"
                component="div"
                rowsPerPageOptions={[5, 10, 25, 50]}
                count={_requestDataCount}
                rowsPerPage={_rowsPerPage}
                page={_page - 1}
                SelectProps={{
                    inputProps: {
                        roboto: "rows per page",
                    },
                    native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={() => ''}
            />

            {/* Right side: Pagination */}
            <Pagination
                count={Math.ceil(_requestDataCount / _rowsPerPage)}
                onChange={handleChangePage1}
                page={_page}
                variant="outlined"
                size="small"
                color="primary"
                shape="rounded"
                renderItem={(item) => (
                    <PaginationItem sx={{ mx: '4px' }} {...item} />
                )}
            />
        </div>
    </>);
}

export default Report;
